import { Injectable } from '@angular/core';
import { RedirectCommand, Resolve } from '@angular/router';
import { Staff } from '@wsphere/staff/domain';

@Injectable()
export class StaffResolver implements Resolve<Staff.Model | null | RedirectCommand> {
  staff: Staff.Model | null = null;

  resolve() {
    return this.staff;
  }
}
